import { roles, phoneNumbers } from '../models/enums'
import AuthService from '../services/auth.service'
/* this function is used to provide default values for phone numbers
 *  for technicians to call when they need assistance.
 *  This should not be used for reschedule job functionality or
 *  the system on test "limit reached" functionality
 */
export default function retrievePhoneByRole() {
  if (AuthService.HasRole(roles.BRINKS_TECH)) {
    return phoneNumbers.FIELD_TECH_DISPATCH
  } else if (
    AuthService.HasRole(roles.DEALER_TECH) ||
    AuthService.HasRole(roles.TECH_APP_ADMIN)
  ) {
    return phoneNumbers.GENERAL
  } else {
    return phoneNumbers.GENERAL
  }
}
